import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Route protection wrapper for Tenant Admin routes
 * Allows Admin and Platform Admin users, redirects others to unauthorized page
 * Handles authorization errors gracefully
 * Requirements: 11.5, 12.3
 */
interface TenantAdminRouteProps {
  children: React.ReactNode;
}

const TenantAdminRoute: React.FC<TenantAdminRouteProps> = ({ children }) => {
  const { currentUser, loading, isAuthorizationError, isTenantAdmin } = useAuth();

  // Show loading state while fetching user
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  // Redirect on authorization errors
  if (isAuthorizationError) {
    return <Navigate to="/unauthorized" replace />;
  }

  // Redirect if not Admin or Platform Admin
  if (!currentUser || !isTenantAdmin) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <>{children}</>;
};

export default TenantAdminRoute;
